








































import SelectYearMounth from "@/shared/components/select-year-mounth.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import Leads from "./Leads.vue";
import Estatisticas from "./estatistica/Estatisticas.vue";
import PesquisarLeads from "./PesquisarLeads.vue";

@Component({
  components: { Leads, PesquisarLeads, Estatisticas, SelectYearMounth },
  filters: {},
})
export default class Funil extends mixins(GlobalMixin) {}
